export function extractTenantFromLocation(
  loc: Location | (Location & { hostname: string; search?: string }) = window.location
): string | null {
  const host = (loc.hostname || '').toLowerCase();
  if (!host) return 'allgemein';

  if (host === 'localhost' || isIpAddress(host)) return 'allgemein';

  const labels = host.split('.');
  if (labels.length < 2) return 'allgemein';

  const tenant = labels[0]?.trim();
  return tenant ? tenant.toLowerCase() : 'allgemein';
}

function isIpAddress(host: string): boolean {
  if (host.includes(':')) return true; // IPv6
  return /^(\d{1,3}\.){3}\d{1,3}$/.test(host);
}
